// src/services/authService.js
import { MAIN_API } from "../config/api";
console.log('MAIN_API URL:', MAIN_API); // ✅ Add this line
const authService = {
  // Login user with role-based endpoint
  login: async (identifier, password, role) => {
    console.log('=== LOGIN ATTEMPT ===');
    console.log('Role selected:', role);
    console.log('Identifier:', identifier);
    console.log('Password:', password ? '****' : 'empty');

    try {
      // Map role to endpoint
      let endpoint = '';
      if (role === 'user') {
        endpoint = `${MAIN_API}/user/login`;
      } else if (role === 'admin') {
        endpoint = `${MAIN_API}/admin/login`;
      } else if (role === 'vendor') {
        endpoint = `${MAIN_API}/vendor/login`;
      } else {
        throw new Error('Invalid role selected');
      }

      console.log('Endpoint:', endpoint);

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          identifier,
          password
        }),
      });

      console.log('Response status:', response.status);

      const data = await response.json();
      console.log('Response data:', data);

      // Check if login was successful
      if (data.success) {
        console.log('Login successful!');
        // Store user data in localStorage
        localStorage.setItem('user', JSON.stringify({
          id: data.data.id,
          name: data.data.name,
          email: data.data.email,
          mobileNumber: data.data.mobileNumber,
          role: data.data.role,
        }));
        localStorage.setItem('role', role);

        console.log('Stored in localStorage:', {
          user: localStorage.getItem('user'),
          role: localStorage.getItem('role')
        });
      } else {
        console.log('Login failed:', data.message);
      }

      return data;
    } catch (error) {
      console.error('Error in login:', error);
      throw { success: false, message: error.message || 'Login failed. Please try again.' };
    }
  },



  // Register user with role-based endpoint
  // Register user with role-based endpoint
  register: async (userData, role) => {
    try {
      let endpoint = '';
      if (role === 'Innovator') {
        endpoint = `${MAIN_API}/user/register`;
      } else if (role === 'admin') {
        endpoint = `${MAIN_API}/admin/register`;
      } else if (role === 'vendor') {
        endpoint = `${MAIN_API}/vendor/register`;
      } else if (role === 'expert') {
        // When expert API is available, update this
        // For now, using user register endpoint
        endpoint = `${MAIN_API}/user/register`;
        console.warn('Expert registration using user endpoint - update when API is available');
      } else {
        throw new Error('Invalid role selected');
      }

      console.log('Register endpoint:', endpoint);
      console.log('Register data:', userData);

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

      const data = await response.json();
      console.log('Register response:', data);
      return data;
    } catch (error) {
      console.error('Register Error:', error);
      throw { success: false, message: error.message || 'Registration failed. Please try again.' };
    }
  },

  // Logout user
  logout: () => {
    localStorage.removeItem('user');
    localStorage.removeItem('role');
  },

  // Get current user
  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  // Get user role
  getUserRole: () => {
    return localStorage.getItem('role');
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!localStorage.getItem('user');
  },
};

export default authService;